<!-- eslint-disable -->

<template>
  <div class='lt-welcome-page'>
    <header
      class='lt-welcome-page_content'
      v-html="clientConfig.content.welcome.content"
      aria-label='Introduction'
    ></header>

      <MDBBtn
        class='footer lt-button'
        @click='startQuiz'
        aria-label='Start building your future'

      >{{ clientConfig.content.welcome.buttonLabel }}
      </MDBBtn>

      <MDBBtn
        v-if="debugMode"
        class='footer lt-button debugMode'
        @click="goToPage('results')"
        aria-label='Results'

      >Results
      </MDBBtn>

      <div style=" opacity: 0; width:1px; height:1px">
        <img src="Q2-AC.jpg" alt="">
        <img src="Q2-AB.jpg" alt="">
        <img src="Q2-AA.jpg" alt="">
        <img src="Q1-AA.jpg" alt="">
        <img src="Q1-AB.jpg" alt="">
        <img src="Q3-AA.jpg" alt="">
        <img src="Q3-AB.jpg" alt="">
        <img src="Q3-AC.jpg" alt="">
        <img src="Q4-AA.jpg" alt="">
        <img src="Q4-AB.jpg" alt="">
        <img src="Q4-AC.jpg" alt="">
        <img src="Q5-AA.jpg" alt="">
        <img src="Q5-AB.jpg" alt="">
        <img src="Q5-AC.jpg" alt="">
        <img src="Q6-AA.jpg" alt="">
        <img src="Q6-AB.jpg" alt="">
        <img src="Q6-AC.jpg" alt="">
        <img src="Q7-AA.jpg" alt="">
        <img src="Q7-AB.jpg" alt="">
        <img src="Q7-AC.jpg" alt="">
        <img src="Q8-AA.jpg" alt="">
        <img src="Q8-AB.jpg" alt="">
        <img src="Q8-AC.jpg" alt="">
        <img src="Q9-AA.jpg" alt="">
        <img src="Q9-AB.jpg" alt="">
        <img src="Q9-AC.jpg" alt="">
        <img src="Q10-AA.jpg" alt="">
        <img src="Q10-AB.jpg" alt="">
        <img src="Q10-AC.jpg" alt="">
      </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import clientConfig from '/src/config/client.js';
import {
  MDBBtn
} from "mdb-vue-ui-kit";

export default {
  components: {
    MDBBtn
  },
  data() {
    return {
      clientConfig
    }
  },
  methods: {
    ...mapMutations([
      'resetScene',
      'goToNextPage',
      'goToPage'
    ]),
    startQuiz () {
      this.resetScene();
      this.goToNextPage();

      this.$gtag.event('custom_event', {
        'event_category' : 'start_journey',
      })
    },
  },
  computed: {
    ...mapGetters(['debugMode']),
  }
};
</script>
